import {
  DataEntityPresenterModel,
  DataEntryPresenterModel,
  DataTypeEnum,
  FieldPresenterModel,
  RefProperty,
} from '@osos/shared/types';

export function flattenEntry(
  entry: DataEntryPresenterModel,
  entity: DataEntityPresenterModel,
): {
  [key: string]: RefProperty | any;
} {
  const compoundKeysToFlat = getCompoundEntityFields(entity.fields);
  return _flattenEntry(entry.value, compoundKeysToFlat);
}

export function getCompoundEntityFields(
  fields: FieldPresenterModel[],
  acc = [],
): string[] {
  fields.forEach((field) => {
    if (
      field.dataType === DataTypeEnum.Block &&
      !!field.block?.internalEntity?.fields.length
    ) {
      acc.push(field._normalizedName);
      if (field.block?.internalEntity?.fields.length) {
        getCompoundEntityFields(field.block?.internalEntity?.fields, acc);
      }
    } else {
      if (field._normalizedName.indexOf('.') > 0) {
        acc.push(field._normalizedName);
      }
    }
  });
  return acc;
}

function _flattenEntry(
  object,
  compoundKeysToFlat: Array<string>,
  separator = '.',
): {
  [key: string]: RefProperty | any;
} {
  return Object.keys(object).reduce((acc, key) => {
    if (
      typeof object[key] !== 'object' ||
      !object[key] ||
      Array.isArray(object[key]) ||
      compoundKeysToFlat.indexOf(key) === -1
    ) {
      return {
        ...acc,
        [key]: object[key],
      };
    }

    const flattenedChild = _flattenEntry(
      object[key],
      compoundKeysToFlat,
      separator,
    );

    return {
      ...acc,
      ...Object.keys(flattenedChild).reduce(
        (childAcc, childKey) => ({
          ...childAcc,
          ...(compoundKeysToFlat.indexOf(`${key}${separator}${childKey}`) && {
            [`${key}${separator}${childKey}`]: flattenedChild[childKey],
          }),
          ...(!compoundKeysToFlat.indexOf(`${key}${separator}${childKey}`) && {
            [`${key}${separator}${childKey}`]: object[key],
          }),
        }),
        {},
      ),
    };
  }, {});
}
